// Absolute links to a sister site in the same network (the footer's site list
// and a model page's "Also on" links). `host` is the sister's public domain
// from the API, e.g. "tiny4k.com".
//
// On production every link goes to the sister's real domain. Local and
// staging hosts carry the site in their first label ("passion-hd.lvh.me",
// "tiny4k.staging.amavalet.com"), so there the label is swapped and the link
// stays on the same environment.
const NON_PRODUCTION_HOST = /(\.lvh\.me|\.lan|\.staging\.amavalet\.com)$/

export const sisterSiteUrl = (requestUrl, host, path = "/") => {
  if (!host) return null

  const current = new URL(requestUrl)
  const label = host.split(".")[0]

  if (NON_PRODUCTION_HOST.test(current.hostname)) {
    const [, ...rest] = current.hostname.split(".")
    current.hostname = [label, ...rest].join(".")
    return `${current.origin}${path}`
  }

  return `https://${host}${path}`
}

export const sisterModelUrl = (requestUrl, site) =>
  site?.slug
    ? sisterSiteUrl(
        requestUrl,
        site.host,
        `/models/${encodeURIComponent(site.slug)}`,
      )
    : null
